export const API_HOST = process.env.VUE_APP_API_HOST || 'https://api.fixtender.net';
export const API_WS_HOST = process.env.VUE_APP_API_WS_HOST || 'wss://api.fixtender.net';
export const APP_HOST = process.env.VUE_APP_HOST || 'https://fixtender.stride.one';

// We need to change graphql endpoints for using with local backend
export const API_GRAPHQL_HOST = process.env.VUE_APP_API_GRAPHQL_HOST || API_HOST;

export const WITHOUT_TRACKERS = process.env.VUE_APP_WITHOUT_TRACKERS === 'true' || false;

export const SUPPORT_LINK = 'https://help.fixtender.com';
